import InvoiceModel from '@/models/claim/InvoiceModel'
import PurchaseModel from '@/models/claim/PurchaseModel'
import CosmosJobsDbRecordBase from '@/models/CosmosJobsDbRecordBase'
export default class FinancialSummaryModel extends CosmosJobsDbRecordBase {
  public invoice: InvoiceModel
  public purchase: PurchaseModel
}
